import React from 'react'
import { ProgressTracker } from '@scentregroup/ui'
import { Link } from '@scentregroup/shared/link'
import {
  CHECKOUT_FULFILMENT,
  CHECKOUT_PAYMENT,
  ORDER_CONFIRMATION,
} from '../../paths'
import style from './index.module.scss'
import { enableProgressTracker } from './utils/enableProgressTracker'

export { enableProgressTracker }

export const enum CheckoutProgressStep {
  Fulfilment = 'Fulfilment',
  Payment = 'Payment',
  Completed = 'Completed',
}

interface ICheckoutProgressProps {
  currentStep?: CheckoutProgressStep
}

export const CHECKOUT_STEPS = [
  {
    label: CheckoutProgressStep.Fulfilment,
    to: CHECKOUT_FULFILMENT,
    disabled: true,
  },
  {
    label: CheckoutProgressStep.Payment,
    to: CHECKOUT_PAYMENT,
    disabled: true,
  },
  {
    label: CheckoutProgressStep.Completed,
    to: ORDER_CONFIRMATION,
    disabled: true,
  },
]

const CheckoutProgress: React.FunctionComponent<
  React.PropsWithChildren<ICheckoutProgressProps>
> = ({ currentStep }) => {
  const steps = CHECKOUT_STEPS
  const currentIndex = steps.findIndex(({ label }) => label === currentStep)

  if (currentStep !== CheckoutProgressStep.Completed) {
    for (let i = 0; i < currentIndex; i += 1) {
      steps[i].disabled = false
    }
  }

  return (
    <div className={style.checkoutProgressWrap}>
      <ProgressTracker
        steps={steps}
        currentStepIndex={currentIndex}
        element={Link}
        className={style.checkoutProgress}
        stepIndexClassName={style.stepIndex}
      />
    </div>
  )
}

export default CheckoutProgress
